import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputBase from '@material-ui/core/InputBase'
import ExpandMore from '@material-ui/icons/ExpandMore'
import {LIST_OPTIONS, BASE_SORT_LIST_OPTIONS, PLAN_SORT_LIST_OPTIONS} from './Constants'

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    fontSize: '0.9rem',
    padding: '8px 26px 9px 12px',
    // transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#4c1b9b',
    },
  },
}))(InputBase)


export const isValidSort = (tipo, sort) => {
  const arr = LIST_OPTIONS[tipo]
  const isValid = !!arr.find(opt => opt.value === sort)
  return {
    isValid, 
    newValid: isValid 
      ? sort 
      : (sort === BASE_SORT_LIST_OPTIONS[1].value || sort === PLAN_SORT_LIST_OPTIONS[1].value) ? arr[1].value : arr[0].value 
  }
}

export default class OrdenLista extends Component {
  static propTypes = {
    onChangeFiltros: PropTypes.func.isRequired,
    sort: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  handleChange = (event) => {
    this.props.onChangeFiltros({name: 'sort', value: event.target.value})
  }

  render() {
    return (
      <div className="vista-vendedor-orden-lista">
        <FormControl fullWidth>
          <Select
            displayEmpty 
            id="vista-vendedor-sort-select"
            value={this.props.sort || ''}
            onChange={this.handleChange}
            input={<BootstrapInput />}
            IconComponent={ExpandMore}
          >
            {LIST_OPTIONS[this.props.tipo]?.map((option) => {
              return (
                <MenuItem key={option.value} value={option.value}>
                  {option.name}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }
}